import type { TranslationTree } from '../../types';

export const modules: TranslationTree = {
  modules: {
    labels: {
      tracabilite: 'Traceability',
      analytic: 'Analytics',
      'adaptcut-connector': 'Adaptcut Connector',
      'machine-learning': 'Machine Learning',
      labelisation: 'Labelling',
      'tool-recommender': 'Tool Eco-Design',
    },
    descriptions: {
      tracabilite: 'Real-time tracking of production submissions.',
      analytic: 'Advanced statistics and tailored dashboards.',
      'adaptcut-connector': 'Bridge Adaptcut (Odoo) data into ToolLife.',
      'machine-learning': 'Predictive models to anticipate anomalies.',
      labelisation: 'Image labelling sessions for model training.',
      'tool-recommender': 'Genetic-algorithm-based milling tool recommendations.',
    },
  },
};
